const customerIoClient: CustomIoClientType = ({ formId, siteId }) => {
  return {
    submitForm: async (data, hiddenFields) => {
      const content = {
        ...data,
        _cio_html_form_id: formId,
        _cio_html_form_name: "",
        _cio_html_form_url: window.document.location,
        _cio_site_id: siteId,
      };

      const response = await fetch(
        "https://eu.customerioforms.com/custom_forms/submit_snippet",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: [
            ...Object.entries(content).map(
              ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                  value as string,
                )}`,
            ),
            ...Object.keys(data)
              // Hidden fields need to be filtered out
              .filter((key) => !hiddenFields.includes(key))
              .map((key) => `_cio_html_form_inputs=${encodeURIComponent(key)}`),
          ].join("&"),
        },
      );

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad response from server");
      }
    },
  };
};

export default customerIoClient;

type CustomIoClientType = (options: { formId: string; siteId: string }) => {
  submitForm: (
    data: { [key: string]: string | boolean },
    hiddenFields: Array<string>,
  ) => Promise<void>;
};
